import React from 'react';
import { Breakpoint } from 'react-socks';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import i18n from '../../../i18n/i18n';

import LazyImage from '../../../components/LazyImage';

import locationIcon from "../../../images/owners/location-icon.png";
import handshakeIcon from "../../../images/owners/handshake-icon.png";
import moneyTreeIcon from "../../../images/owners/money-tree-icon.png";

const operationList = [
  {
    image: locationIcon,
    caption: i18n.t("owners.operationBanner.provideDetails"),
    alt: "location-icon"
  },
  {
    image: handshakeIcon,
    caption: i18n.t("owners.operationBanner.agreeTnC"),
    alt: "handshake-icon"
  },
  {
    image: moneyTreeIcon,
    caption: i18n.t("owners.operationBanner.sitBack"),
    alt: "money-tree-icon"
  }
]

const OperationBanner = () => {
  return (
    <div className="w-full bg-[url('./images/owners/operation-background.png')] bg-center bg-cover bg-no-repeat p-[25px] md:py-[50px] md:px-[70px] lg:py-[30px] lg:px-[150px] xl:px-[250px] 2xl:px-[350px]">
      <div className="flex flex-col my-[30px] md:my-[50px]">
        <div className="mb-[20px] text-white text-[35px] font-bold leading-tight md:text-[45px]">{i18n.t("owners.operationBanner.title")}</div>
        <div className="mb-[20px] text-[14px] text-[#858280] md:text-[16px]">{i18n.t("owners.operationBanner.description")}</div>
        <div className="flex flex-col items-center my-[10px] lg:flex-row lg:my-[30px] lg:justify-center">
          {operationList.map((operation, index) => (
            <div className="flex flex-row items-center" key={`operation-${index}`}>
              <div className="flex flex-col items-center">
                <div className="w-[250px] h-[230px] flex flex-col items-center">
                  <LazyImage className="w-[120px] mt-[20px] object-contain lg:w-[150px] lg:mt-[0px]" src={operation.image} alt={operation.alt} />
                  <div className="w-[230px] mt-[20px] text-[14px] text-white font-bold text-center md:text-[16px]">{operation.caption}</div>
                </div>
                <Breakpoint customQuery="(max-width: 1023px)">
                  {index !== (operationList.length - 1) && <FontAwesomeIcon className="mt-[30px] text-white text-[25px]" icon={faChevronDown} />}
                </Breakpoint>
              </div>
              <Breakpoint customQuery="(min-width: 1024px)">
                {index !== (operationList.length - 1) && <FontAwesomeIcon className="mx-[20px] text-white text-[25px]" icon={faChevronRight} />}
              </Breakpoint>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default OperationBanner;